import SITE from './site';

export default SITE;
